export const GENERIC_ERROR_MESSAGE = 'Datele afişate pot fi incomplete';
export const WRONG_LOGIN_CREDENTIALS = 'Email-ul sau parola sunt incorecte';
export const COMMENT_ADDED = 'Comentariul a fost adăugat cu succes';
export const NEWS_ADDED_TO_FAVORITE = 'Ştirea a fost adăugata la favorite';
export const REMOVED_NEWS_FROM_FAVORITE = 'Ştirea a fost ştearsă de la favorite';
export const WRONG_PASSWORD = 'Parola introdusă nu este corecta';
export const WRONG_TEMPORARY_PASSWORD = 'Parola temporală a fost introdusă greșit';
export const CHANGE_PASSWORD_SUCCEEDED_MESSAGE = 'Parola a fost schimbată';
export const SELECTED_QUANTITIES_EXCEDED = "Numărul de bilete selectate este mai mare decât numărul locurilor selectate";
export const SELECTED_QUANTITIES_SMALLER_THAN_EXPECTED = "Numărul de bilete selectate este mai mic decât numărul locurilor selectate";
export const PAYMENT_GENERIC_ERROR = "Plata nu a putut fi efectuată, vă rugăm reveniţi mai târziu";
export const CONTACT_MESSAGE = "Informaţiile au fost trimise";
export const USER_ALREADY_EXISTS = 'Email-ul acesta exista deja înregistrat';
export const NOT_AVAILABLE_SEATS = 'Locurile selectate nu mai sunt disponibile';


// WEBPACK FOOTER //
// ./src/SHARED/config/messages.js